import { AbstractParentEntity } from "./AbstractParentEntity";
import { Bank } from "./base$Bank";
import { PersonGroupExt } from "./base$PersonGroupExt";
export class PersonBankDetails extends AbstractParentEntity {
  static NAME = "tsadv_PersonBankDetails";
  bank?: Bank | null;
  fullNameBankCard?: string | null;
  iban?: string | null;
  bicBank?: string | null;
  personGroup?: PersonGroupExt | null;
  startDateHistory?: any | null;
  startDate?: any | null;
  endDate?: any | null;
  endDateHistory?: any | null;
}
export type PersonBankDetailsViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "personBankDetails-for-integration"
  | "personBankDetails.browse"
  | "personBankDetails.edit";
export type PersonBankDetailsView<
  V extends PersonBankDetailsViewName
> = V extends "_base"
  ? Pick<
      PersonBankDetails,
      | "id"
      | "fullNameBankCard"
      | "iban"
      | "bicBank"
      | "startDateHistory"
      | "startDate"
      | "endDate"
      | "endDateHistory"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_local"
  ? Pick<
      PersonBankDetails,
      | "id"
      | "fullNameBankCard"
      | "iban"
      | "bicBank"
      | "startDateHistory"
      | "startDate"
      | "endDate"
      | "endDateHistory"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "personBankDetails-for-integration"
  ? Pick<
      PersonBankDetails,
      | "id"
      | "fullNameBankCard"
      | "iban"
      | "bicBank"
      | "startDateHistory"
      | "startDate"
      | "endDate"
      | "endDateHistory"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "bank"
      | "personGroup"
    >
  : V extends "personBankDetails.browse"
  ? Pick<
      PersonBankDetails,
      | "id"
      | "fullNameBankCard"
      | "iban"
      | "bicBank"
      | "startDateHistory"
      | "startDate"
      | "endDate"
      | "endDateHistory"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "bank"
      | "personGroup"
    >
  : V extends "personBankDetails.edit"
  ? Pick<
      PersonBankDetails,
      | "id"
      | "fullNameBankCard"
      | "iban"
      | "bicBank"
      | "startDateHistory"
      | "startDate"
      | "endDate"
      | "endDateHistory"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "bank"
      | "personGroup"
    >
  : never;
